/* eslint-disable */

<template>
  <card class="form-card">
    <template slot="header">
      <div class="form-title">{{ title }}</div>
    </template>
    <template>
      <div class="row justify-content-center">
        <div class="col">
          <fg-input 
            type="text"
            label="Username or Email"
            v-model="username_or_email">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <fg-input 
            type="password"
            label="Password"
            v-model="password">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <fg-input 
            type="text"
            label="Billing Email Address"
            v-model="billing_email_address">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center last-input">
        <div class="col">
          <card-input :submitting_billing_info="submitting_billing_info" v-on:errorHandler="errorHandler" v-on:stripeTokenHandler="stripeTokenHandler"></card-input>
        </div>
      </div>
      <div class="row justify-content-center">
        <default-button :buttonText="get_started" :processing-click="submitting_billing_info" v-on:onButtonClicked="submitBillingInfo" />
      </div>
    </template>
  </card>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import DefaultButton from '@/components/UIComponents/Buttons/DefaultButton.vue'
  import CardInput from './CardInput.vue'
  import axios from 'axios'

  export default {
    components: {
      Card,
      CardInput,
      DefaultButton,
    },
    data: function () {
      return {
        title: "Merchant Billing Setup",
        username_or_email: "",
        password: "",
        billing_email_address: "",
        get_started: "GET STARTED",
        submitting_billing_info: false,
      }
    },
    methods: {
      submitBillingInfo () {
        this.submitting_billing_info = true;
      },
      errorHandler () {
        this.submitting_billing_info = false;
      },
      stripeTokenHandler(token) {
        var payload = {
          username_or_email: this.username_or_email,
          password: this.password,
          billing_email: this.billing_email_address,
          stripeToken: token
        }

        axios.put(this.$store.state.endpoints.billing, payload)
          .then((response)=>{
            this.$router.push('/login');
          })
          .catch((error)=>{
            console.log(error);
            this.submitting_billing_info = false;
          })
      }
    },
  }
</script>
